import store from '@/state/store';
import { confirmLoginByPhone } from '@/api/auth';
import authenticationSlice from '@/state/authentication.slice';
import { AuthenticationStatus } from '@/contracts';
import { initSession } from '@/loaders/profile';
import { handleError } from '../common';
import { Logger } from '@bimdata/client';
import t from '@/utils/translate';

export default async (code: string) => {
  const state = store.getState();
  if (state.authentication.status !== AuthenticationStatus.PENDING_CONFIRMATION) {
    Logger.warn(t('authentication.message.invalidMethodCall'));
    return;
  }

  const claim = state.authentication.claimId as string;

  store.dispatch(authenticationSlice.actions.startConfirmation());
  try {
    await confirmLoginByPhone({ code, claim });
    store.dispatch(authenticationSlice.actions.finishLogin());
    await initSession();
  } catch (error) {
    store.dispatch(authenticationSlice.actions.waitPhoneConfirmation(claim));
    handleError(error);
  }
};
